export default {
  THIRD_PARTY_MOBILE_APPLICATION: 'thirdPartyMobileApplication',
  QR_CODE: 'qrcode',
  HARDLINK: 'hardlink',
  TRADE_EMAIL: 'tradeEmail',
  RETURN_TO_FINANCE_APP_HARDLINK: 'returnToFinanceAppHardLink',
  RETURN_TO_FINANCE_APP_CREDIT_EMAIL: 'returnToFinanceAppCreditEmail',
};
